import { ProtectedRoute } from 'auth/ProtectedRoute';
import { ConsentRoute } from 'components/ConsentRoute';
import { FC, PropsWithChildren } from 'react';

export type MghRouteProps = PropsWithChildren & {
  ignoreDataConsent?: boolean;
};

export const MghRoute: FC<MghRouteProps> = ({ children, ignoreDataConsent }) => (
  <ProtectedRoute>
    {ignoreDataConsent ? children : <ConsentRoute>{children}</ConsentRoute>}
  </ProtectedRoute>
);
